import { Injectable } from '@angular/core';
import { MessageService } from '@sla-ng/core';
import { CostUnitResource } from '../../../resources/cost-unit.resource';
import { ICostUnit } from '../../../models/cost-unit.model';
import { FieldType } from '@sla-ng/ui-material';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { ICostUnitState } from './cost-unit-state.model';

let _state: ICostUnitState = {
    columns: [ 'name', 'articleNr', 'edit-button' ],
    dialogFields: [
        { field: 'name', label: 'app.model.cost-unit.name.label', type: FieldType.text, required: true },
        { field: 'articleNr', label: 'app.model.cost-unit.articleNr.label', type: FieldType.text, required: true },
    ],
    loading: false,
};

@Injectable({
    providedIn: 'root',
})
export class CostUnitFacade {

    protected store$: BehaviorSubject<ICostUnitState> = new BehaviorSubject<ICostUnitState>(_state);

    constructor(private myCostUnitResource: CostUnitResource,
                private myMessageService: MessageService) {
    }

    public async addCostUnit(costUnit: ICostUnit): Promise<void> {
        const createdCostUnit: ICostUnit = await this.myCostUnitResource.createCostUnit(costUnit).toPromise().catch(()=>null);
        if (createdCostUnit !== null) {
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.cost-unit.actions.added.label');
        }
    }

    public async editCostUnit(costUnit: ICostUnit): Promise<void> {
        const editedCostUnit: ICostUnit = await this.myCostUnitResource.updateCostUnit(costUnit).toPromise().catch(()=>null);
        if (editedCostUnit !== null) {
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.cost-unit.actions.edited.label');
        }
    }

    public async deleteCostUnit(costUnitId: number): Promise<void> {
        this.setIsloading(true);
        try {
            await firstValueFrom(this.myCostUnitResource.deleteCostUnit(costUnitId));
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.cost-unit.actions.deleted.label');
        } catch (e) {
            console.error(e);
        }
        this.setIsloading(false);
    }

    public subState(): Observable<ICostUnitState> {
        return this.store$.asObservable();
    }

    private updateState(state: ICostUnitState): void {
        this.store$.next(_state = state);
    }

    private setIsloading(loading: boolean): void {
        this.updateState({ ..._state, loading });
    }
}
